let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i8F9y")).then(() => parcelRequire('3NTky'));